import jsPDF from "jspdf";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { logoBlack, priorityPrint } from "../../../constants/images";
// import { ResiWoodpackingDisplay } from "../../../shared/resi-woodpacking-display";
import { createSolidBadge, setFontAuto, shiftX } from "./utils";

export const renderFooterHeader = (params: {
  doc: jsPDF | any;
  baseX: number;
  footerTopY: number;
  headerSeparatorY: number;
  leftMargin: number;
  logoAspectRatio: number;
  data: PrintDataEntitas;
  barcodeValue: string;
  shipmentId: string;
  language: string;
  translate: Function;
  // woodpackingDisplay?: ResiWoodpackingDisplay;
}) => {
  const doc = params.doc;

  doc.addImage(
    logoBlack,
    "PNG",
    params.leftMargin,
    params.footerTopY + 4,
    16,
    params.logoAspectRatio * 16,
    "logo-footer",
    "FAST",
    0
  );

  const productType = String(params.data.sttProductType || "").toUpperCase();
  const productX = params.leftMargin + 22;
  doc.setFont("Inter", "extrabold");

  const leftSeparatorX = shiftX(params.baseX + 46);
  const solidBadgeFontSize = 8;
  const badgeGap = 1;
  const productRightPaddingToSeparator = 0.5;
  const separatorToBadgeGap = 0.5;
  const maxProductW = Math.max(
    10,
    leftSeparatorX - productRightPaddingToSeparator - productX
  );

  let productFontSize = 7;
  while (productFontSize > 3.5) {
    if (
      doc.getTextDimensions(productType, { fontSize: productFontSize }).w + 4 <=
      maxProductW
    ) {
      break;
    }
    productFontSize -= 0.5;
  }

  const productText = productType;
  doc.setFontSize(productFontSize);
  doc.setFillColor("#333333");
  doc.setDrawColor("#333333");
  const productW =
    doc.getTextDimensions(productText, { fontSize: productFontSize }).w + 4;
  doc.roundedRect(productX, params.footerTopY + 4, productW, 4, 1, 1, "F");
  doc.setTextColor("#FFFFFF");
  doc.text(productText, productX + 2, params.footerTopY + 7);
  doc.setTextColor("#333333");

  let badgeX = leftSeparatorX + separatorToBadgeGap + 2;
  // if (
  //   params.woodpackingDisplay?.showKayuBadge ??
  //   params.data.sttIsWoodpacking
  // ) {
  //   const rect = createSolidBadge(
  //     doc,
  //     "PK",
  //     badgeX,
  //     params.footerTopY + 3.5,
  //     solidBadgeFontSize
  //   );
  //   badgeX += rect.w + badgeGap;
  // }
  if (params.data.isDangerousGoods) {
    const rect = createSolidBadge(
      doc,
      "DG",
      badgeX,
      params.footerTopY + 3.5,
      solidBadgeFontSize
    );
    badgeX += rect.w + badgeGap;
  }
  if (params.data.sttCommodityIsQuarantine) {
    const rect = createSolidBadge(
      doc,
      "K",
      badgeX,
      params.footerTopY + 3.5,
      solidBadgeFontSize
    );
    badgeX += rect.w + badgeGap;
  }
  if (params.data.isPriorityTier) {
    doc.addImage(
      priorityPrint,
      "PNG",
      badgeX,
      params.footerTopY + 3.5,
      5,
      5,
      "logo-priority-print",
      "FAST"
    );
    badgeX += 5 + badgeGap;
  }

  const billedX = shiftX(params.baseX + 86);
  doc.setFont("Inter", "extrabold");
  doc.setFontSize(7);
  const translatedChargeableWeight = String(
    params.translate("receipt.chargeableWeight")
  );
  const chargeableWeightLabel =
    translatedChargeableWeight === "receipt.chargeableWeight"
      ? "Berat\nDitagihkan"
      : translatedChargeableWeight;
  const chargeableWeightLines = chargeableWeightLabel.split("\n");
  const chargeableWeightLine1 = String(
    chargeableWeightLines[0] || chargeableWeightLabel
  ).toUpperCase();
  const chargeableWeightLine2 = String(
    chargeableWeightLines[1] || ""
  ).toUpperCase();
  doc.text(chargeableWeightLine1, billedX, params.footerTopY + 5);
  if (chargeableWeightLine2)
    doc.text(chargeableWeightLine2, billedX, params.footerTopY + 7.5);
  const billedWeight = `${params.data.sttChargeableWeight} kg`;
  setFontAuto(doc, billedWeight, "bold");
  doc.setFontSize(12);
  doc.text(billedWeight, billedX, params.footerTopY + 12.4);

  const sttNo = String(params.data.sttNo || params.barcodeValue || "");
  setFontAuto(doc, sttNo, "bold");
  doc.setFontSize(9);
  doc.text(sttNo, params.leftMargin, params.footerTopY + 11.75);

  const clientName = String(params.data.sttClientName || "");
  // batas 30 karakter + "..." supaya tidak menembus garis pemisah (GENESIS-24619)
  let elipsisClientName =
    clientName.length > 30 ? `${clientName.substring(0, 30)}...` : clientName;
  while (
    elipsisClientName.length > 4 &&
    doc.getTextDimensions(elipsisClientName, { fontSize: 5 }).w > 36
  ) {
    elipsisClientName = `${elipsisClientName.substring(
      0,
      elipsisClientName.length - 4
    )}...`;
  }
  doc.setFontSize(5);
  setFontAuto(doc, elipsisClientName, "bold");
  doc.text(elipsisClientName, params.leftMargin, params.footerTopY + 14.25);

  const commodityText =
    params.language === "en"
      ? String(params.data.sttCommodityDescription || "")
      : String(params.data.sttCommodityName || "");
  doc.setFontSize(5);
  setFontAuto(doc, commodityText, "medium");
  const commodityLines = doc.splitTextToSize(commodityText, 38);
  doc.text(
    commodityLines,
    shiftX(params.baseX + 48),
    params.footerTopY + 11.25
  );

  doc.setLineWidth(0.4);
  doc.line(
    shiftX(params.baseX + 46),
    params.footerTopY + 2.5,
    shiftX(params.baseX + 46),
    params.headerSeparatorY - 4
  );
  doc.line(
    shiftX(params.baseX + 83),
    params.footerTopY + 2.5,
    shiftX(params.baseX + 83),
    params.headerSeparatorY - 4
  );
};
